<template>
  <CSInput :type="isPwd ? 'password' : 'text'">
    <template #before>
      <CSIcon name="fa-light fa-lock" />
    </template>
    <template #append>
      <CSIcon
        :name="isPwd ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
        size="0.7em"
        class="cursor-pointer"
        @click="isPwd = !isPwd"
      />
    </template>
  </CSInput>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CSInput from "./CSInput.vue";
import CSIcon from "./CSIcon.vue";

const isPwd = ref(true);
</script>
